export const VALIDATE_SCP_TOKEN = '/auth';
